(function () {
  'use strict';

  var STORAGE_PREFIX = 'mountainside_wishlist_';
  var GUEST_KEY = STORAGE_PREFIX + 'guest';

  function getCustomerId() {
    if (window.CUSTOMER_ID && String(window.CUSTOMER_ID).length > 0 && String(window.CUSTOMER_ID) !== 'null') {
      return String(window.CUSTOMER_ID);
    }
    return null;
  }

  function isLoggedIn() {
    return getCustomerId() !== null;
  }

  function storageKey() {
    var id = getCustomerId();
    return id ? STORAGE_PREFIX + id : GUEST_KEY;
  }

  function readList() {
    try {
      var raw = window.localStorage.getItem(storageKey());
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(storageKey(), JSON.stringify(list));
    } catch (e) {}
  }

  function has(handle) {
    if (!handle) return false;
    return readList().indexOf(String(handle)) !== -1;
  }

  function add(handle) {
    if (!handle) return;
    var list = readList();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      writeList(list);
    }
  }

  function remove(handle) {
    if (!handle) return;
    var list = readList();
    var i = list.indexOf(handle);
    if (i !== -1) {
      list.splice(i, 1);
      writeList(list);
    }
  }

  function count() {
    return readList().length;
  }

  function updateHeaderCount() {
    var els = document.querySelectorAll('[data-wishlist-count]');
    var c = count();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.textContent = c;
      if (c > 0) {
        el.classList.add('visible');
      } else {
        el.classList.remove('visible');
      }
    }
  }

  function syncButtonState(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (has(handle)) {
      btn.classList.add('is-wishlisted');
      btn.setAttribute('aria-pressed', 'true');
      var label = btn.querySelector('[data-wishlist-label]');
      if (label && btn.getAttribute('data-label-added')) {
        label.textContent = btn.getAttribute('data-label-added');
      }
    } else {
      btn.classList.remove('is-wishlisted');
      btn.setAttribute('aria-pressed', 'false');
      var label2 = btn.querySelector('[data-wishlist-label]');
      if (label2 && btn.getAttribute('data-label-add')) {
        label2.textContent = btn.getAttribute('data-label-add');
      }
    }
  }

  function syncAllButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-button]');
    for (var i = 0; i < buttons.length; i++) {
      syncButtonState(buttons[i]);
    }
  }

  function showToast(message) {
    var toast = document.querySelector('[data-wishlist-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.setAttribute('data-wishlist-toast', '');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    if (toast._timer) clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function showLoginPrompt(returnUrl) {
    var modal = document.querySelector('[data-wishlist-login-modal]');
    if (!modal) return;
    var link = modal.querySelector('[data-wishlist-login-link]');
    if (link) {
      var target = '/account/login';
      if (returnUrl) {
        target += '?return_url=' + encodeURIComponent(returnUrl);
      }
      link.setAttribute('href', target);
    }
    modal.classList.add('is-open');
    document.body.classList.add('wishlist-modal-open');
  }

  function hideLoginPrompt() {
    var modal = document.querySelector('[data-wishlist-login-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('wishlist-modal-open');
  }

  function handleButtonClick(e) {
    var btn = e.target.closest('[data-wishlist-button]');
    if (!btn) return;
    e.preventDefault();

    if (!isLoggedIn()) {
      var returnUrl = window.location.pathname + window.location.search;
      showLoginPrompt(returnUrl);
      return;
    }

    var handle = btn.getAttribute('data-wishlist-handle');
    var title = btn.getAttribute('data-wishlist-title') || 'Product';
    if (!handle) return;

    if (has(handle)) {
      remove(handle);
      showToast(title + ' removed from wishlist');
    } else {
      add(handle);
      showToast(title + ' added to wishlist');
    }
    syncButtonState(btn);
    updateHeaderCount();

    if (document.body.classList.contains('template-page') && document.querySelector('[data-wishlist-page-grid]')) {
      renderWishlistPage();
    }
  }

  function fetchProductCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-product-item]');
        return card || null;
      })
      .catch(function () { return null; });
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-page-grid]');
    var empty = document.querySelector('[data-wishlist-page-empty]');
    if (!grid) return;

    var handles = readList();
    if (handles.length === 0) {
      grid.innerHTML = '';
      grid.style.display = 'none';
      if (empty) empty.style.display = '';
      return;
    }

    if (empty) empty.style.display = 'none';
    grid.style.display = '';
    grid.innerHTML = '<li class="wishlist-loading">Loading your wishlist…</li>';

    Promise.all(handles.map(fetchProductCard)).then(function (cards) {
      var validHandles = [];
      var frag = document.createDocumentFragment();
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (!card) continue;
        card.setAttribute('data-wishlist-card', '');
        card.setAttribute('data-wishlist-card-handle', handles[i]);

        var heart = card.querySelector('[data-wishlist-button]');
        if (heart) heart.parentNode.removeChild(heart);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'wishlist-card__remove';
        removeBtn.setAttribute('data-wishlist-remove-card', '');
        removeBtn.setAttribute('data-handle', handles[i]);
        removeBtn.setAttribute('aria-label', 'Remove from wishlist');
        removeBtn.innerHTML = '&times;';
        card.appendChild(removeBtn);

        frag.appendChild(card);
        validHandles.push(handles[i]);
      }
      if (validHandles.length !== handles.length) {
        writeList(validHandles);
        updateHeaderCount();
      }
      grid.innerHTML = '';
      if (validHandles.length === 0) {
        grid.style.display = 'none';
        if (empty) empty.style.display = '';
        return;
      }
      grid.appendChild(frag);
      syncAllButtons();
    });
  }

  function handleCardRemove(e) {
    var btn = e.target.closest('[data-wishlist-remove-card]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    remove(handle);
    updateHeaderCount();
    syncAllButtons();
    renderWishlistPage();
  }

  function handleModalClose(e) {
    if (e.target.closest('[data-wishlist-login-close]') || e.target.hasAttribute('data-wishlist-login-overlay')) {
      hideLoginPrompt();
    }
  }

  function nodeHasWishlistButton(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('[data-wishlist-button]')) return true;
    return !!(node.querySelector && node.querySelector('[data-wishlist-button]'));
  }

  function init() {
    document.addEventListener('click', handleButtonClick, false);
    document.addEventListener('click', handleCardRemove, false);
    document.addEventListener('click', handleModalClose, false);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideLoginPrompt();
    });
    syncAllButtons();
    updateHeaderCount();
    if (document.querySelector('[data-wishlist-page-grid]')) {
      renderWishlistPage();
    }

    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      if (scheduled) return;
      var needsSync = false;
      for (var i = 0; i < mutations.length && !needsSync; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (nodeHasWishlistButton(added[j])) {
            needsSync = true;
            break;
          }
        }
      }
      if (!needsSync) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncAllButtons();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MountainsideWishlist = {
    has: has,
    add: add,
    remove: remove,
    count: count,
    refresh: function () {
      syncAllButtons();
      updateHeaderCount();
    }
  };
})();
